import {persistReducer, persistStore} from 'redux-persist';
import {rootPersistConfig, rootReducer} from './rootReducer';
import * as toolkitRaw from '@reduxjs/toolkit';

const {configureStore} = toolkitRaw.default ?? toolkitRaw;
// import { configureStore } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

const persistor = persistStore(store);

const {dispatch} = store;

export {dispatch, persistor, store};
